import { useUserContext } from '@/Context/UserContext';
import { getDatabase, onValue, ref } from 'firebase/database';
import { useEffect, useState } from 'react';

const UnSeenMessages = () => {
  const { user } = useUserContext();
  const userId = user?.id;
  const [messagesCount, setMessagesCount] = useState(0);

  useEffect(() => {
    if (!userId) return;
    const unsubscribe = onValue(ref(getDatabase(), `PatientChatCount/${userId}`), (snapshot) => {
      let value = 0;
      snapshot.forEach(item => {
        if (item.val() > 0) value += item.val();
      });
      setMessagesCount(value);
    })

    return () => {
      unsubscribe();
    }
  }, [userId]);

  if (messagesCount === 0) return <div />

  return (<>
    <div className="w-3 h-3 rounded-full bg-red-base absolute -top-1 -right-1 border-2 border-white animate-ping" />
    <div className="w-2 h-2 rounded-full bg-red-base absolute top-[-2px] right-[-2px]" />
  </>
  )
}


export default UnSeenMessages;